<template>
  <div class="alibabaPuHuiTiFontFamily" style="width: calc(100vw - 52px);min-height: 100vh;overflow-y: scroll;background: #020F1F;color: #808080;padding-left: 26px;padding-right: 26px;padding-bottom: 59px;position: relative;">
    <div v-if="isShare" style="position: fixed;height: 90px;width: 100vw;background: #020F1F;display: flex;align-items: center;justify-content: center;top: 0;left: 0;right: 0;">
      <div @click="$router.back()" class="iconfontFamily" style="position: absolute;left: 33px;color: white;font-size: 13px;">&#xe7d1;</div>
      <div style="font-size: 16px;color: white;">卫星帮拍规则</div>
    </div>
    <div :style="{marginTop: isShare ? '90px' : '10px'}">
      活动时间：本活动自2025年12月上线试运营，后续若有调整，见活动页面。
    </div>
    <div style="margin-top: 20px;">参与条件：</div>
    <div>1.须为共生地球APP注册用户。</div>
    <div style="margin-top: 20px;">参与方式：</div>
    <div>1. 活动时间内，符合参与条件的用户登录共生地球APP（须更新至最新版本），点击首页-菜单-活动，进入本活动页面，根据页面提示选择拟帮拍区域、填写140字内积极健康的专属寄语，提交后即完成参与，有机会获得卫星帮拍资格。</div>
    <div style="margin-top: 20px;">2. 主办方将为帮拍进度完成100%的用户提供卫星拍摄影像回传服务。</div>
    <div style="margin-top: 20px;">3. 因卫星轨道运行规律、天气条件（如云层遮挡、极端气象）等不可控因素，卫星帮拍存在一定失败概率。若帮拍失败，主办方将及时通知用户。</div>
    <div style="margin-top: 20px;">4. 帮拍成功后，主办方将在卫星完成拍摄后的1-2个工作日内，通过APP活动页面向用户交付拍摄成果（形式为卫星遥感图像分辨率以实际拍摄为准）。</div>
    <div style="margin-top: 20px;">注意事项：</div>
    <div>1. 严禁任何违规操作，包括但不限于：提交虚假信息、冒用他人身份、多账号参与；指定帮拍区域涉及军事禁区、涉密场所、私人领域等禁拍范围；寄语含低俗违法、违背公序良俗内容；利用技术漏洞、外挂作弊获取帮拍资格；将拍摄成果用于非法传播、商业牟利等违规用途。</div>
    <div style="margin-top: 20px;">2. 若用户存在上述违规行为，APP运营方及主办方有权取消其活动参与资格、收回已交付的拍摄成果，且不予补偿。</div>
    <div style="margin-top: 20px;">3. 帮拍资格抽取、拍摄进度及成果交付状态以活动系统记录为准，因网络延迟、设备故障、APP版本未更新等非用户原因导致的参与异常，可联系共生地球小助手（提供截图）反馈，经核实后可协助处理。</div>
    <div style="margin-top: 20px;">4. 帮拍成果著作权归主办方所有，用户获得非商业性使用权，可用于个人收藏、分享（需注明主办方及活动来源），不得用于商业及违规场景。</div>
    <div style="margin-top: 20px;">5. 账号因违规被封禁期间，已获得的帮拍资格及未领取的拍摄成果将同步冻结，封禁期间相关权益有效期不予顺延。</div>
    <div style="margin-top: 20px;">6. 本活动规则最终解释权归共生地球APP运营团队及长光卫星技术股份有限公司共同所有，如有疑问可通过共生地球APP客服咨询（工作日8:30-17:30）。</div>
  </div>
</template>

<script>
export default {
  name: 'SatelliteShootRule',
  data() {
    return {
      isShare: false,
    }
  },
  mounted() {
    this.isShare = this.$route.query.share === '1'
  }
}
</script>

<style scoped>

</style>